module.exports = __webpack_public_path__ + "img/sikertelen.74e56f1b.png";